import styles from "@/components/common/copy/styles/copy-text-bar.module.scss";
import CopyToClipboardButton from "@/components/common/copy/copy-to-clipboard-button";
import { ToastContainer } from "react-toastify";

type CopyTextBarProps = {
  text: string;
};

const CopyTextBar = ({ text }: CopyTextBarProps) => {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.text_wrapper}>{text}</div>
        <div className={styles.copy_button_wrapper}>
          <CopyToClipboardButton textToCopy={text} size={20} />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default CopyTextBar;
